import React, { useEffect } from "react";
import { Container, } from "react-bootstrap";
import { connect } from "react-redux";
import { DeleteTeamMemberApi, UpdateTeamMemberApi } from "./TeamMemberAction";
import { baseURL, headers } from "../../../../../global/api";
import { setHeading } from "../../../accounts/account.actions";
import MaterialSize from "material-table";


const ViewTeamMember = (props) => {

    useEffect(() => {
        props.setHeading("Team Member List");
    }, []);

    return (
        <>
            <Container fluid>
                <MaterialSize
                    title="Team Member List"
                    columns={[
                        { title: 'Sequence Number', field: 'sequenceNumber', editable: 'never' },
                        { title: "Name", field: "name" },
                        { title: "Father Name", field: "fatherName" },
                        { title: "Resident ID", field: "residentID" },
                        { title: "Department", field: "department" },
                        { title: "Qualification", field: "qualification" },
                        { title: "Employee Type", field: "employeeType", editable: 'never' },
                        { title: "Created By", field: "userDetails.userName", editable: 'never' },
                    ]}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            let url = `${baseURL}/teamMember?`;
                            url += "limit=" + query.pageSize;
                            url += "&page=" + (query.page);
                            url += "&search=" + query.search;
                            fetch(url, {
                                method: "GET",
                                headers: headers,
                            }).then((response) => response.json()).then((result) => {
                                resolve({
                                    data: result.data,
                                    page: result.page,
                                    totalCount: result.total_results,
                                });
                            });
                        })
                    }
                    options={{
                        actionsColumnIndex: -1,
                        exportButton: true,
                        exportAllData: true,
                        paging: true,
                        pageSize: 50,
                        emptyRowsWhenPaging: false,
                        pageSizeOptions: [50, 100, 150, 200],
                        headerStyle: {
                            position: "sticky",
                            top: 0,
                            color: "#00BBBB",
                            fontWeight: "550",
                            onRowAdd: "none",
                        },
                    }}
                    editable={{
                        // isEditHidden: (rowData) => Checkpermissions("permissionsSubCatName", "Colour Edit"),
                        // isDeleteHidden: (rowData) => Checkpermissions("permissionsSubCatName", "Colour Delete"),
                        onRowUpdate: (newData, oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    props.UpdateTeamMemberApi(newData, oldData);
                                }, 600);
                            }),
                        onRowDelete: (oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    props.DeleteTeamMemberApi(oldData._id);
                                }, 600);
                            }),
                    }}
                />
            </Container>
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        DeleteTeamMemberApi: (id) => dispatch(DeleteTeamMemberApi(id)),
        UpdateTeamMemberApi: (newData, oldData) => dispatch(UpdateTeamMemberApi(newData, oldData)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isFetchingTeamMember: state.TeamMemberReducer.isFetchingTeamMember,
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewTeamMember);